import React from 'react'
import HighchartsReact from 'highcharts-react-official';
import Highcharts from 'highcharts/highstock';
import '../../pages/Table.css'
const CategoryWisePostsTable = (props) => {
    const { community } = props;

    return (

        <div className="tableWrapper">
            <table className="table-auto border-collapse border border-gray-400 fixed_header">
                <thead>
                    <tr className="">
                        <th className="border p-2 text-bold">Category Title</th>
                        <th className="border p-2 text-bold">Num Posts</th>
                    </tr>

                </thead>
                <tbody className="trhover">
                    {community?.category_post?.map((data) => (
                        <tr>
                            <td className="border p-2">{data?.title}</td>
                            <td className="border p-2">{data?.post_count}</td>

                        </tr>
                    ))}
                </tbody>
            </table>
        </div>


    )


}

export default CategoryWisePostsTable